export const LOCAL_STORAGE_LOCAL_TOKEN_KEY = 'bfb-onboarding-local-token'

export const setLocalStorageLocalToken = (token: string) => {
  localStorage.setItem(LOCAL_STORAGE_LOCAL_TOKEN_KEY, token)
}

export const getLocalStorageLocalToken = () =>
  localStorage.getItem(LOCAL_STORAGE_LOCAL_TOKEN_KEY)

export const removeLocalStorageLocalToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_LOCAL_TOKEN_KEY)
}

export const LOCAL_STORAGE_RISK_PROFILE_KEY = 'bfb-onboarding-risk-profile'

export const setLocalStorageRiskProfile = (value: unknown[]) => {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(
    LOCAL_STORAGE_RISK_PROFILE_KEY,
    JSON.stringify(value)
  )
}

export const getLocalStorageRiskProfile = () => {
  if (typeof window === 'undefined') {
    return []
  }

  return JSON.parse(
    window.localStorage.getItem(LOCAL_STORAGE_RISK_PROFILE_KEY) || '[]'
  )
}

export const clearLocalStorageRiskProfile = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.removeItem(LOCAL_STORAGE_RISK_PROFILE_KEY)
}

export const LOCAL_STORAGE_ONBOARDING_FORM_TOKEN_KEY =
  'bfb-onboarding-form-token'

export const setLocalStorageOnboardingFormToken = (formToken: string) => {
  localStorage.setItem(LOCAL_STORAGE_ONBOARDING_FORM_TOKEN_KEY, formToken)
}

export const getLocalStorageOnboardingFormToken = () =>
  localStorage.getItem(LOCAL_STORAGE_ONBOARDING_FORM_TOKEN_KEY)

export const removeLocalStorageOnboardingFormToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_ONBOARDING_FORM_TOKEN_KEY)
}

// Config Feature
export const setLocalStorageConfigFeature = (data: Record<string, any>) => {
  const stringifyData = encodeURIComponent(JSON.stringify(data))
  const decodedData = window.btoa(stringifyData)
  localStorage.setItem('b--config-feature', decodedData)
}

export const getLocalStorageConfigFeature = () => {
  const item = localStorage.getItem('b--config-feature') || 'JTdCJTdE'
  const decodedItem = decodeURIComponent(window.atob(item))
  return JSON.parse(decodedItem)
}
